import {Component} from '@angular/core';

import {ModalController, NavController, NavParams} from 'ionic-angular';


import {LicitacaoService} from '../../../../providers/licitacao-service';
import {AlertService} from '../../../../providers/alert-service';
import {MenuService} from '../../../../providers/menu-service';
import {ModulosController} from '../../modulos-controller';
import {UsuarioService} from '../../../../providers/usuario-service';
import {GestaoPcaService} from '../../../../providers/gestao-pca-service';

@Component({
  selector: 'page-relatorio-inspecao',
  templateUrl: 'relatorio-inspecao.html',
  providers: [
    LicitacaoService
  ]
})
export class LicitacaoRelatorioInspecaoPage extends ModulosController {
  listaDados: any;
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "61";

  order: string = 'nrProcesso';
  reverse: boolean = true;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public licitacaoService: LicitacaoService,
    //private document: DocumentViewer,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();
    this.setModuloId(7);
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = false;
      this.order = "-" + value;
    } else {
      this.reverse = true;
      this.order = value;
    }
  }

  carregarDados() {
    this.licitacaoService.obterRelatorioInspecao().subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  formatarPorcentagem(valor) {
    return valor.toString().replace('.', ',') + "%";
  }

  voltar() {
    this.menuService.redirecionarPagina(this.licitacaoService.obterIdPaginaLicitacao());
  }

  salvarComentario(enviarMensagem = true) {
    this.loading = true;
    this.listaDados.resumoAnalise = this.capitalize(this.listaDados.resumoAnalise);
    this.licitacaoService.salvarRelatorioInspecao(this.listaDados, this.idSecaoPagina).subscribe(data => {
      if (enviarMensagem) {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
        this.loading = false;
      } else {
        this.licitacaoService.submeterAnaliseNoCertificado(this.listaDados.idModuloAnalise, this.listaDados, this.idSecaoPagina).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltar();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
          this.loading = false;
        });
      }
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      this.loading = false;
    })
  }

  submeterNoCertificado() {
    this.loading = true;
    console.log(this.listaDados.resumoAnalise)
    this.listaDados.resumoAnalise = this.capitalize(this.listaDados.resumoAnalise);
    if (this.listaDados.resumoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resumoAnalise == null || this.listaDados.resumoAnalise == undefined || !this.listaDados.resumoAnalise) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
      this.loading = false;
    } else {
      if (this.listaDados) {

        this.salvarComentario(false);
      }
    }
  }

  baixarRelatorioCompleto(idDoc) {
    this.licitacaoService.downloadRelatorioInspecao(idDoc);
  }

  capitalize(str) {
    let retorno = "";

    if (str) {
      retorno = str.charAt(0).toUpperCase() + str.slice(1);
    }

    return retorno;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/licitacao/relatorio-inspecao/relatorio-inspecao.ts